// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const cif: CountryValidator<"ES"> = createValidator(
  "es.cif",
  65,
);

export default cif;
export const compact = cif.compact;
export const format = cif.format;
export const validate = cif.validate;
export const generate = (): string =>
  cif.generate?.() ??
  (() => {
    throw new Error(
      "Validator es.cif cannot generate values",
    );
  })();
